import React, {
  useEffect,
  useReducer,
  useRef,
  useState,
  useContext,
} from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import "../../../assets/css/RJ_V1/custom.css";
import FbViewPixel from "../../../Utility/FbViewPixel";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP";
import GetVisitorsParams from "../../../Utility/GetVisitorsParams";
import Footer from "../../Includes/Layouts/Footer/Footer_RJV1";
import Header from "../../Includes/Layouts/Header/HeaderRJV1";
import GTMDataLayer from "../../../Utility/GTMDataLayer";
import {
  manageFormSlides,
  generateInitialSlideState,
} from "../../Pages/LUFP_RJ_V1/formSlideReducer";
import BasicPersonalDetails from "../LUFP_RJ_V1/BasicPersonalDetails";
import DateOfBirth from "../LUFP_RJ_V1/DateOfBirth";
import IdentityVerification from "../LUFP_RJ_V1/IdentityVerification";
import ContactInfo from "../LUFP_RJ_V1/ContactInfo";

import { useDataIngestion } from "../../../Hooks/useDataIngestion";
import VisitorParamsContext from "../../../Contexts/VisitorParams";
import { getQueryString } from "../../../Utility/QueryString";
import * as EnvConstants from "../../../Constants/EnvConstants";
import { getBuyerName } from "../../Includes/Layouts/Common/BuyerBasedOnDomain";

let submitOnceClicked = false;

const TOTAL_STEPS = 4;

export const ErrorMsg = ({ msg }) => {
  if (!msg) return null;
  return <p className="error_msg">{msg}</p>;
};

const RJ_V1 = () => {
  const history = useHistory();
  const [currentStep, setCurrentStep] = useState(1);
  const [isNextActive, setIsNextActive] = useState(false);
  const [showCompletePopup, setShowCompletePopup] = useState(false);

  const { visitorParameters } = useContext(VisitorParamsContext);
  const { saveDataIngestion, isLoading } = useDataIngestion();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const queryString = getQueryString();
  const splitName = "oa/RJ_DF_V1";
  const nextPage = "oa/rj-signature";
  const atp_source = new URLSearchParams(queryString).get("atp_source") ?? "";
  const { brand, b_id } = getBuyerName();

  const [pCodemanual, setPcodemanual] = useState(0);
  const vendorRef = useRef("");

  // Refs to child components with custom validation logic
  const dobRef = useRef(null);
  const identityRef = useRef(null);
  const contactInfoRef = useRef(null);

//   useEffect(() => {
//     document.body.style.backgroundColor = "#ecf4ef";
//     return () => {
//       document.body.style.backgroundColor = "";
//     };
//   }, []);

  const {
    register,
    formState: { errors, isValid },
    trigger,
    setError,
    clearErrors,
    getValues,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {},
  });

  const [state, dispatch] = useReducer(
    manageFormSlides,
    generateInitialSlideState(TOTAL_STEPS)
  );

  // Fields to validate per step
  const fieldsPerStep = {
    1: ["lstSalutation", "txtFName", "txtLName"],
    2: ["txtDOBDay", "txtDOBMonth", "txtDOBYear"],
    3: ["txtPostCode", "txtAddress"],
    4: ["txtEmail", "txtPhone"],
  };

  const handleNextOrSubmit = async () => {
    if (isButtonDisabled) return;

    if (currentStep === TOTAL_STEPS) {
      await contactInfoRef.current?.handleNext({ preventDefault: () => {} });
      return;
    }

    if (currentStep === 3) {
      await identityRef.current?.handleNext();
      return;
    }

    if (currentStep === 2) {
      await dobRef.current?.handleNext();
      return;
    }

    const valid = await trigger(fieldsPerStep[currentStep]);
    if (!valid) return;

    const nextStep = currentStep + 1;
    setCurrentStep(nextStep);
    setIsNextActive(false); // reset for next slide
    dispatch({ type: "showSlide", payload: { slide: `next${currentStep}` } });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Keep slideChange for backward compatibility with child back-buttons
  const slideChange = (e) => {
    const name = e.target.name;
    const nextStep = parseInt(name.replace("next", "")) + 1;
    setCurrentStep(nextStep);
    setIsNextActive(false);
    dispatch({ type: "showSlide", payload: { slide: name } });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  
  const previousSlideChange = (backSlide) => {
    const backToStep = parseInt(backSlide.replace("back", ""));
    setCurrentStep(backToStep);
    setIsNextActive(true); // previous slide was already valid
    dispatch({ type: "showSlide", payload: { slide: backSlide } });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const showPopupIfValid = () => {
    setShowCompletePopup(true);
  };

  const handleSubmit = async () => {
    if (submitOnceClicked) return;
    setIsButtonDisabled(true);

    const values = getValues();
    const formData = {
      ...values,
      pCode_manual: pCodemanual,
      vendor: vendorRef.current,
    };

    if (!formData.txtPhone || formData.txtPhone.length < 10) {
      setError("txtPhone", {
        type: "manual",
        message: "Please Enter Valid Mobile Number",
      });
      setIsButtonDisabled(false);
      setShowCompletePopup(false);
      return;
    }

    if (
      !formData.txtEmail ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+[^\s@.]$/.test(formData.txtEmail)
    ) {
      setError("txtEmail", {
        type: "manual",
        message: "Please Enter Valid Email Address",
      });
      setIsButtonDisabled(false);
      setShowCompletePopup(false);
      return;
    }

    if (visitorParameters.data) {
      localStorage.setItem("formData", JSON.stringify(formData));
      localStorage.setItem("fName", formData.txtFName);
      submitOnceClicked = true;

      const formSUbmitResult = await saveDataIngestion(
        visitorParameters.visitor_parameters,
        formData,
        "split_form_submit",
        splitName,
        queryString,
        visitorParameters.data
      );

      if (formSUbmitResult.data?.duplicate === false) {
        GTMDataLayer({
          clickEvent: "conversion",
          leadID: visitorParameters.visitor_parameters.uuid,
          email: formData.txtEmail,
          phone: formData.txtPhone,
          brand: "OA",
          account: atp_source,
        });
      }

      const creditVendor = formSUbmitResult?.data?.credit_vendor ?? "";
      if (creditVendor !== "") {
        localStorage.setItem("credit_vendor", creditVendor);
      }
      if(creditVendor == 'checkboard') {
        loader = 'address-verification';
      }

      let loader = "oa/rj-signature";

      if (formSUbmitResult.data.duplicate === true) {
        history.push(
          "/followup" +
            "?uuid=" +
            formSUbmitResult.data.uuid +
            "&splitName=" +
            splitName +
            "&atp_sub6=FLP_DUP"
        );
      } else if (formSUbmitResult.data.type === "db_maintenance") {
        history.push(
          "/scheduled-maintenance?uuid=" +
            visitorParameters.visitor_parameters.uuid +
            "&splitName=" +
            splitName
        );
      } else {
        setIsButtonDisabled(false);
        const urlParams = `?uuid=${visitorParameters.visitor_parameters.uuid}&splitName=${splitName}&nextPage=${nextPage}`;

        if (
          queryString?.indexOf("&pid=") !== -1 &&
          EnvConstants.AppConversionPixel === "true"
        ) {
          history.push(
            `/oa/fbpixel?${queryString}&next_page=${loader}&nextPage=${nextPage}&splitName=${splitName}`
          );
        } else {
          window.scrollTo(0, 0);
          history.push(`/${loader}${urlParams}`);
        }
      }
    }
  };

  const progressPct = ((currentStep - 1) / (TOTAL_STEPS - 1)) * 100;

  const btnLabel = currentStep === TOTAL_STEPS ? "Submit" : "Continue";

  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="oa/RJ_DF_V1" />
      <FbViewPixel />
      <GetVisitorsParams />
      <Header />

      <main
        className="flex-grow-1 w-100 mx-auto px-3 d-flex flex-column align-items-center mw-48rem"
        style={{ paddingBottom: "7rem" }}
      >
        {/* ── Progress Bar ── */}
        <div className="d-flex align-items-center justify-content-center w-100 mx-auto mb-3 mt-3 position-relative mw-400">
          <div
            className="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center px-3"
            style={{ zIndex: 0 }}
          >
            <div className="w-100 bg-gray-200 h-2px"></div>
            <div
              className="position-absolute transition-all progress-line"
              style={{ width: `${progressPct}%` }}
            ></div>
          </div>

          <div className="d-flex justify-content-between w-100 position-relative z-10">
            {Array.from({ length: TOTAL_STEPS }, (_, i) => {
              const step = i + 1;
              const isActive = step <= currentStep;
              return (
                <div
                  key={step}
                  className="step-indicator step-dot d-flex align-items-center justify-content-center rounded-circle fw-bold shadow-sm transition-colors"
                  style={{
                    backgroundColor: isActive ? "#27b394" : "#ffffff",
                    color: isActive ? "#ffffff" : "#6b7280",
                    borderColor: isActive ? "#27b394" : "#e5e7eb",
                    border: "1px solid",
                  }}
                  data-step={step}
                />
              );
            })}
          </div>
        </div>

        {/* ── Form container ── */}
        <form
          id="claim-form"
          className="w-100 bg-white shadow-sm overflow-hidden position-relative border border-gray-100-half p-4 p-md-5 pb-5 rounded-16"
          onSubmit={(e) => e.preventDefault()}
        >
          <BasicPersonalDetails
            slideChange={slideChange}
            slideView={state.showSlide1}
            register={register}
            validationMsg={errors}
            trigger={trigger}
            clearErrors={clearErrors}
            getValues={getValues}
            setError={setError}
            watch={watch}
            isValid={isValid}
            setIsNextActive={setIsNextActive}
          />

          <DateOfBirth
            ref={dobRef}
            slideChange={slideChange}
            slideView={state.showSlide2}
            previousSlideChange={previousSlideChange}
            register={register}
            validationMsg={errors}
            trigger={trigger}
            clearErrors={clearErrors}
            setError={setError}
            getValues={getValues}
            watch={watch}
            isValid={isValid}
            setIsNextActive={setIsNextActive}
          />

          <IdentityVerification
            ref={identityRef}
            slideChange={slideChange}
            slideView={state.showSlide3}
            previousSlideChange={previousSlideChange}
            register={register}
            validationMsg={errors}
            trigger={trigger}
            clearErrors={clearErrors}
            getValues={getValues}
            setError={setError}
            setValue={setValue}
            watch={watch}
            setPcodemanual={setPcodemanual}
            vendorRef={vendorRef}
            isValid={isValid}
            setIsNextActive={setIsNextActive}
          />

          <ContactInfo
            ref={contactInfoRef}
            slideView={state.showSlide4}
            previousSlideChange={previousSlideChange}
            register={register}
            validationMsg={errors}
            trigger={trigger}
            clearErrors={clearErrors}
            getValues={getValues}
            setError={setError}
            formSubmit={showPopupIfValid}
            isButtonDisabled={isButtonDisabled}
            isLoading={isLoading}
            watch={watch}
            isValid={isValid}
            setIsNextActive={setIsNextActive}
          />
        </form>
      </main>

      {/* ── Sticky Footer Button ── */}
      <div
        className={`bg-gray-50 border-top border-gray-100 py-4 text-center w-100 ${showCompletePopup ? "d-none" : ""}${
            currentStep === 3 ? "identity-sticky-btn" : ""}`}
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <div className="mx-auto px-3 mw-36rem">
          <button
            type="button"
            id="next-btn"
            onClick={handleNextOrSubmit}
            disabled={!isNextActive || isButtonDisabled}
            className={`w-100 mx-auto py-3 rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 transition-all border-0 mw-360 ${
              isNextActive && !isButtonDisabled ? "btn-active" : "btn-disabled"
            }`}
            style={{ fontSize: "1.125rem" }}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Please wait...</span>
              </>
            ) : (
              <>
                <span id="btn-text">{btnLabel}</span>
                <svg
                  id="btn-icon"
                  className="icon-lg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>

      <Footer />

      {/* ── Completion Popup ── */}
      <div
        id="complete-popup"
        className={`position-fixed inset-0 d-flex align-items-center justify-content-center bg-black-50 backdrop-blur-sm px-3 z-50 ${showCompletePopup ? "" : "d-none"}`}
      >
        <div className="bg-white rounded-4 shadow-lg w-100 p-5 text-center animate-pop-in mw-28rem">
          {/* Green checkmark */}
          <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4 shadow-lg avatar-2xl bg-brand-medium">
            <svg
              className="icon-2xl text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={3}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 className="fs-5 fw-bolder text-gray-900 mb-3">
            Congratulations, we’ve matched you with Olton Alexander Limited!
          </h2>
          <p className="text-gray-600 leading-relaxed mb-4 fs-14">
            Join the over 300,000+ clients who have already started their
            claim(s) with our partner claims management company Olton Alexander
            Limited, with just a few simple steps.
          </p>
          <button
            type="button"
            className={`w-100 py-3 rounded-pill fw-bold border-0 mt-3 d-flex align-items-center justify-content-center gap-2 transition-all ${
              isLoading || isButtonDisabled ? "btn-disabled" : "btn-active"
            }`}
            style={{ fontSize: "1.125rem" }}
            onClick={handleSubmit}
            disabled={isLoading || isButtonDisabled}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Please wait...</span>
              </>
            ) : (
              <>
                <span>Continue</span>
                <svg
                  className="icon-lg text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default RJ_V1;
